import { CareCreditIntegrationV1 } from '@frontend/api-care-credit-integration';
import { InvoiceModel } from '@frontend/api-invoices';
import { getInvoicePayments, isCareCreditPayment } from './care-credit-account-utils';

export const useGetCareCreditAccountNumber = (invoice: InvoiceModel) => {
  const hasCareCreditPayment = getInvoicePayments(invoice).some(isCareCreditPayment);

  const { data: merchantData } = CareCreditIntegrationV1.Queries.useGetMerchantConnectionQuery({
    request: { locationId: invoice.locationId },
    options: { enabled: hasCareCreditPayment },
  });

  const { data: accountData } = CareCreditIntegrationV1.Queries.useAccountLookupQuery({
    request: {
      merchantNumber: merchantData?.merchantNumber,
      phoneNumber: invoice.person.mobilePhone,
      locationId: invoice.locationId,
    },
    options: {
      enabled:
        hasCareCreditPayment && !!merchantData?.merchantNumber && !!invoice.person.mobilePhone && !!invoice.locationId,
    },
  });

  return accountData?.data?.account?.accountInfo?.accountNumber;
};
